import { isJsonResponse } from '@okapi/http';
import { getParamString } from '../utils/get-param-string';
import { relativeRemoteWidgetStateUrl } from '../utils/relative-remote-widget-state-url';
export const loadState = async ({ widget, server, headers = {}, url: propUrl = '/' }) => {
    if (!server && process.env.BEHIND_PROXY !== 'true') {
        return Promise.reject('Failed to load Widget state');
    }
    let paramsData = getParamString({
        url: propUrl,
    });
    const relativeUrl = relativeRemoteWidgetStateUrl(widget);
    const baseUrl = new URL(relativeUrl, server);
    const url = new URL(paramsData, baseUrl);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { connection, ...acceptedHeaders } = headers;
    acceptedHeaders['content-type'] = 'application/json';
    delete acceptedHeaders['content-length'];
    const response = await fetch(url.toString(), {
        method: 'GET',
        headers: acceptedHeaders,
    });
    if (response.ok && isJsonResponse(response, response.headers)) {
        return response.json();
    }
    return Promise.reject('Failed to load Widget state');
};
